export default __webpack_public_path__ + "static/jobsBg-982aee9ccdd11443b4d99d253fe68c0c.webp";